import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-[#382A2A] mt-24 bg-[#110D0D]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-4 gap-10">
        <div>
          <div className="font-serif text-2xl text-[#F7ECEB]">Touche<span className="text-[#E58B5E]">.today</span></div>
          <p className="text-sm text-[#A89896] mt-3 leading-relaxed">
            A private membership for therapeutic touch, intimacy coaching, and embodied wellness.
          </p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-[#C93B3B] mb-4">Explore</div>
          <ul className="space-y-2 text-sm text-[#A89896]">
            <li><Link to="/practitioners" className="hover:text-[#C93B3B]">Practitioners</Link></li>
            <li><Link to="/membership" className="hover:text-[#C93B3B]">Membership</Link></li>
            <li><Link to="/resources" className="hover:text-[#C93B3B]">Library</Link></li>
            <li><Link to="/shop" className="hover:text-[#C93B3B]">Shop</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-[#C93B3B] mb-4">Care</div>
          <ul className="space-y-2 text-sm text-[#A89896]">
            <li>Consent-forward practice</li>
            <li>Trauma-informed care</li>
            <li>Vetted practitioners</li>
            <li>Confidential sessions</li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-[#C93B3B] mb-4">Company</div>
          <ul className="space-y-2 text-sm text-[#A89896]">
            <li><Link to="/about" className="hover:text-[#C93B3B]" data-testid="footer-about">About</Link></li>
            <li><Link to="/contact" className="hover:text-[#C93B3B]" data-testid="footer-contact">Contact</Link></li>
            <li><Link to="/terms" className="hover:text-[#C93B3B]" data-testid="footer-terms">Terms of Use</Link></li>
            <li><Link to="/privacy" className="hover:text-[#C93B3B]" data-testid="footer-privacy">Privacy Policy</Link></li>
            <li className="pt-2">hello@touche.today</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#382A2A] py-6 text-center text-xs text-[#A89896]">
        <span data-testid="footer-copyright">© {new Date().getFullYear()} Touche.Today · Owned and operated by HQPhD Global Ventures LLC</span>
      </div>
    </footer>
  );
}
